"use client";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export default function ReCaptchaProviderWrapper({ children }) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={"6Ldy_fgrAAAAACg11U3R19EsXMRvPM-LB2O_XQzd"}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
